import * as amplitude from '@amplitude/analytics-browser'
import config from '../config'

type User = {
  id: number
  name: string
  email: string
}

function isUser(data: unknown): data is User {
  if (typeof data !== 'object' || data === null) {
    return false
  }

  if ('id' in data && 'name' in data && 'email' in data) {
    return [data.id, data.name, data.email].every(field => typeof field === 'string' || typeof field === 'number')
  }

  return false
}

function getEnvironment() {
  if (import.meta.env.NODE_ENV === 'production') {
    return 'production'
  }

  if (config.STAGING) {
    return 'staging'
  }

  return 'development'
}

const apiKey = import.meta.env?.VITE_AMPLITUDE_KEY

if (getEnvironment() !== 'development') {
  if (typeof apiKey === 'string' && apiKey.length > 0) {
    amplitude
      .init(apiKey, {
        autocapture: {
          attribution: false,
          fileDownloads: false,
          formInteractions: false,
          pageViews: false,
          sessions: false,
          elementInteractions: false,
          networkTracking: false,
          webVitals: false,
          frustrationInteractions: false
        }
      })
      .promise.then(() => {
        if (isUser(window.user)) {
          console.log('Amplitude initialized with user:', window.user)

          amplitude.setIdentity({
            userId: window.user.id.toString().padStart(5, '0'),
            userProperties: {
              name: window.user.name,
              email: window.user.email
            }
          })
        } else {
          console.warn('User data is not available or invalid, Amplitude initialized without user identity')
        }
      })
  } else {
    console.warn('Amplitude API key is not set')
  }
} else {
  console.warn('Amplitude is not initialized in development environment')
}
